const getTextQuestionTime = (textQuestionLength) => {
  if (textQuestionLength > 300) {
    return 60
  }
  return 30
}

export default getTextQuestionTime
